// バトルで使用しないフォームの除外ID一覧
export const EXCLUDED_POKEMON_IDS: number[] = [
  10264, // コライドン(せいげんけいたい)
  10265, // コライドン(しっそうけいたい)
  10266, // コライドン(ゆうえいけいたい)
  10267, // コライドン(かっくうけいたい)
  10268, // ミライドン(リミテッドモード)
  10269, // ミライドン(ドライブモード)
  10270, // ミライドン(フロートモード)
  10271, // ミライドン(グライドモード)
  // ピカチュウ(コスプレ/キャップ等)は通常のダメージ計算では扱わないため除外する
  10080, // ピカチュウ(ハードロック・ピカチュウ)
  10081, // ピカチュウ(マダム・ピカチュウ)
  10082, // ピカチュウ(アイドル・ピカチュウ)
  10083, // ピカチュウ(ドクター・ピカチュウ)
  10084, // ピカチュウ(マスクド・ピカチュウ)
  10085, // ピカチュウ(おきがえピカチュウ)
  10094, // ピカチュウ(オリジナルキャップ)
  10095, // ピカチュウ(ホウエンキャップ)
  10096, // ピカチュウ(シンオウキャップ)
  10097, // ピカチュウ(イッシュキャップ)
  10098, // ピカチュウ(カロスキャップ)
  10099, // ピカチュウ(アローラキャップ)
  10148, // ピカチュウ(キミにきめたキャップ)
  10158, // ピカチュウ([])
  10160, // ピカチュウ(ワールドキャップ)
  10199, // ピカチュウ([])
  10143, // ミミッキュ(ばれたすがた)
  10192, // ザルード(とうちゃん)
];
